<template>
  <v-app>
    <Navigation />
    <v-main>
      <router-view/>
    </v-main>
    <PageFooter />
  </v-app>
</template>

<script>
import Navigation from './components/Navigation.vue'
import PageFooter from './components/PageFooter.vue'

export default {
  name: 'App',
  components: {
    Navigation,
    PageFooter,
  },
  beforeCreate() {
    if (document.location.origin !== 'https://yabbr.com.au') return;

    const headScript = document.createElement('script');
    headScript.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KG9RCLKQ');`

    const bodyScript = document.createElement('noscript');
    bodyScript.innerText = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KG9RCLKQ"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    document.head.insertAdjacentElement('afterBegin', headScript);
    document.body.insertAdjacentElement('afterBegin', bodyScript);
  },
};
</script>
<style lang="scss">
.btn-primary {
  text-transform: none !important;
  background-color: #1582d8 !important;
  // font-weight: 600;
  font-size: $font-size-root !important;
  letter-spacing: 0px;

  &--outline {
    text-transform: none !important;
    background-color: #fff !important;
    border-color:  #1582d8 !important;
    color:   #1582d8 !important;
    // font-weight: 600 !important;
    font-size: $font-size-root !important;
    letter-spacing: 0px;
  }

  &--outline-large {
    text-transform: none !important;
    background-color: #fff !important;
    border-color:  #1582d8 !important;
    color:   #1582d8 !important;
    font-weight: 600 !important;
    font-size: $font-size-root !important;
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  &--mobile {
    width: 90% !important;
  }
}

// .container-pad px-10 {
//     padding-left: 2rem;
//     padding-right: 2rem;
//
//     @include atSmall {
//       padding-left: 6rem !important;
//       padding-right: 6rem !important;
//     }
//
//     @include atExtraLarge {
//         padding-left: 20rem;
//         padding-right: 20rem;
//     }
// }

// .container-left {
//   padding-left: 8.5rem;
//   @include atExtraLarge {
//     padding-left: 20rem;
//   }
// }

.section {
  padding-top: 2rem;
  padding-bottom: 2rem;

  @include atLarge {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  &__header-container {
    // margin-bottom: 3.1rem;

    @include atSmall {
      margin-bottom: 0;
    }

    @include atMedium {
      margin-bottom: 0;
    }
  }

  &__header-title {
    margin-bottom: 1.87rem;
  }

  * {
    max-width: 2000px;
  }
}


</style>
